/**
 * @generated SignedSource<<ae83bb1b059e8bc6e2565f1639ab77dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WaitlistButton_game$data = {
  readonly id: string;
  readonly viewerIsOnWaitingList: boolean;
  readonly " $fragmentType": "WaitlistButton_game";
};
export type WaitlistButton_game$key = {
  readonly " $data"?: WaitlistButton_game$data;
  readonly " $fragmentSpreads": FragmentRefs<"WaitlistButton_game">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WaitlistButton_game",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerIsOnWaitingList",
      "storageKey": null
    }
  ],
  "type": "Game",
  "abstractKey": null
};

(node as any).hash = "ab901d8fa313b4d88b0117ad8e46a479";

export default node;
